import React, { useState, useEffect } from 'react';
import {
    Col,
    Card,
    Button,
} from "react-bootstrap";
import { Link } from 'react-router-dom'
function State() {

    const [data, setData] = useState(
        document.querySelectorAll("#myTable tbody tr")
    );

    const [cols, setCols] = useState([]);
    const [rows, setRows] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);
    const states=[
        {
            id:1,
            name:"Andhra Pradesh",
            path:"andhra-pradesh"
        },
        {
            id:2,
            name:"Arunachal Pradesh",
            path:"arunachal-pradesh"
        },
        {
            id:3,
            name:"Assam",
            path:"assam"
        },
        {
            id:4,
            name:"Bihar",
            path:"bihar"
        },
        {
            id:5,
            name:"Chhattisgarh",
            path:"chattisgarh"
        },
        {
            id:6,
            name:"Delhi",
            path:"delhi"
        },
       
        {
            id:7,
            name:"Goa",
            path:"goa"
        },
        {
            id:8,
            name:"Gujarat",
            path:"gujrat"
        },
        {
            id:9,
            name:"Haryana",
            path:"haryana"
        },
        {
            id:10,
            name:"Himachal Pradesh",
            path:"himachal-pradesh"
        },
        {
            id:11,
            name:"Jharkhand",
            path:"jharkhand"
        },
        {
            id:12,
            name:"Karnataka",
            path:"Karnataka"
        },
        {
            id:13,
            name:"Kerala",
            path:"kerala"
        },
        {
            id:14,
            name:"Madhya Pradesh",
            path:"madhya-pradesh"
        },
        {
            id:15,
            name:"Maharashtra",
            path:"maharastra"
        },
        {
            id:16,
            name:"Manipur",
            path:"manipur"
        },
        {
            id:17,
            name:"Meghalaya",
            path:"meghalaya"
        },
        {
            id:18,
            name:"Mizoram",
            path:"mizoram"
        },
        {
            id:19,
            name:"Nagaland",
            path:"nagaland"
        },
        {
            id:20,
            name:"Odisha",
            path:"odisha"
        },
        {
            id:21,
            name:"Punjab",
            path:"punjab"
        },
        {
            id:22,
            name:"Rajasthan",
            path:"rajasthan"
        },
        {
            id:23,
            name:"Sikkim",
            path:"sikkim"
        },
        {
            id:24,
            name:"Tamil Nadu",
            path:"tamil-nadu"
        },
        {
            id:25,
            name:"Telangana",
            path:"telangana"
        },
        {
            id:26,
            name:"Tripura",
            path:"tripura"
        },
        {
            id:27,
            name:"Uttar Pradesh",
            path:"uttar-pradesh"
        },
        {
            id:28,
            name:"Uttarakhand",
            path:"uttarakhand"
        },
        {
            id:29,
            name:"West Bengal",
            path:"west-bengal"
        },
        {
            id:30,
            name:"Andaman and Nicobar Island",
            path:"andaman"
        },
        {
            id:31,
            name:"Chandigarh",
            path:"chandigarh"
        },
        {
            id:32,
            name:"Dadra and Nagar Haveli and Daman and Diu",
            path:"dadra-nagar"
        },
        {
            id:33,
            name:"Ladakh",
            path:"ladakh"
        },
        {
            id:34,
            name:"Lakshadweep",
            path:"lakshadweep"
        },
        {
            id:35,
            name:"Jammu and Kashmir",
            path:"jammu-kashmir"
        },
        {
            id:36,
            name:"Puducherry",
            path:"puducherry"
        },
       
        
    ]
    const column = [
        {
            title: "LOCATION",
            dataIndex: "location",
            editable: true
        },
        {
            title: "PINCODE",
            dataIndex: "pincode",
            editable: true
        },
        {
            title: "STATE",
            dataIndex: "state",
            editable: true
        },
        {
            title: "DISTRICT",
            dataIndex: "district",
            editable: true
        },
    ]

    useEffect(() => {
        setData(document.querySelectorAll("#myTable tbody tr"));
        chackboxFun();
    }, []);

    const chackbox = document.querySelectorAll(".sorting_1 input");
    const motherChackBox = document.querySelector(".sorting_asc input");
    const chackboxFun = (type) => {
        for (let i = 0; i < chackbox.length; i++) {
            const element = chackbox[i];
            if (type === "all") {
                if (motherChackBox.checked) {
                    element.checked = true;
                } else {
                    element.checked = false;
                }
            } else {
                if (!element.checked) {
                    motherChackBox.checked = false;
                    break;
                } else {
                    motherChackBox.checked = true;
                }
            }
        }
    };

    const svg1 = (
        <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect x="0" y="0" width="24" height="24"></rect>
                <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                <circle fill="#000000" cx="19" cy="12" r="2"></circle>
            </g>
        </svg>);

    function searchFunction() {

        var input, filter, table, tr, td, i, txtValue;
        input = document.getElementById("myInput");
        filter = input.value.toUpperCase();
        table = document.getElementById("myTable");
        tr = table.getElementsByTagName("tr");

        for (i = 0; i < tr.length; i++) {
            td = tr[i].getElementsByTagName("td")[1];
            if (td) {
                txtValue = td.textContent || td.innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    tr[i].style.display = "";
                } else {
                    tr[i].style.display = "none";
                }
            }
        }
    }

    const fileHandler = fileList => {
        let fileObj = fileList;
        if (!fileObj) {
            setErrorMessage({
                errorMessage: "No file uploaded!"
            });
            return false;
        }
        if (
            !(
                fileObj.type === "application/vnd.ms-excel" ||
                fileObj.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            )
        ) {
            setErrorMessage({
                errorMessage: "Unknown file format. Only Excel files are uploaded!"
            });
            return false;
        }
        //just pass the fileObj as parameter
        const ExcelRenderer = (fileObj, (err, resp) => {
            if (err) {
            } else {
                let newRows = [];
                resp.rows.slice(1).map((row, index) => {
                    if (row && row !== "undefined") {
                        newRows.push({
                            key: index,
                            location: row[0],
                            pincode: row[1],
                            state: row[2],
                            district: row[3],
                        });
                    }
                });
                if (newRows.length === 0) {
                    setErrorMessage({
                        errorMessage: "No data found in file!"
                    });
                    return false;
                } else {
                    setCols(resp.cols)
                    setRows(newRows)
                    setErrorMessage(null)
                }
            }
        });
        return false;
    };

    const columns = column.map(col => {
        if (!col.editable) {
            return <>col
                <input />
            </>
        }
        return {
            ...col,
            onCell: record => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
            })
        };
    });

    return (
        <Col lg={12}>
            <Card style={{
                color: "white",
                background:
                  "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
              }}>
                <Card.Header>
                    <Card.Title className='text-white'>Geofence State</Card.Title>
                    <div className="input-group search-area d-lg-inline-flex d-none">
                        <div className="input-group-append">
                            <button className="input-group-text">
                                <i className="flaticon-381-search-2" />
                            </button>
                        </div>
                        <input type="text" id="myInput" onKeyUp={searchFunction} className="form-control" placeholder="Search here..." />
                    </div>
                </Card.Header>
                <Card.Body>
                    <table
                        className="display w-100 dataTable"
                        id="myTable"
                        role="grid"
                        aria-describedby="example5_info"
                    >
                        <thead>
                            <tr>
                                <th>
                                    <strong className='text-white'>SL No.</strong>
                                </th>
                                <th>
                                    <strong className='text-white'>STATE & UNION TERRITORIES</strong>
                                </th>
                                <th>
                                    <strong className='text-white'>VIEW</strong>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        {states.map((val=>{
                            return(
                                <tr>
                                <td>
                                    <strong>{val.id}</strong>
                                </td>
                                <td>
                                   {val.name}
                                </td>
                                <td><Link to={`/city/${val.path}`}><Button onClick={()=>{localStorage.setItem("sname",val.path)}} className="btn btn-primary">View</Button></Link></td>
                            </tr>
                            )
                        }))}
                           
                        </tbody>
                    </table>
                </Card.Body>
            </Card>
        </Col>
    )
}

export default State;
